<template>
  <div class="end-modal">
    <div
      class="end-modal-title"
      v-html="$t('קיבלנו את הזמנתך ונציג<br />יצור קשר בהקדם להמשך תהליך')"
    ></div>
    <div class="end-modal-body">
      <img
        class="desktop-bg"
        src="/app/themes/skideal/resources/assets/images/order-modal-background.jpg"
      />
      <img
        class="mobile-bg"
        src="/app/themes/skideal/resources/assets/images/order-modal-background-mobile.png"
      />
      <div>{{ $t("תודה שבחרת SkiDeal") }}</div>
    </div>
  </div>
</template>

<script>
import { $t } from "../../i18n";

export default {
  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
.end-modal {
  padding-top: 11vh;
  padding-bottom: 2vh;

  .end-modal-title {
    color: #2f3e52;
    font-size: 43px;
    font-weight: 900;
    text-align: center;
    margin-bottom: 3vh;

    @media screen and (max-width: 991px) {
      color: #2f3e52;
      font-size: 25px;
      margin-bottom: 4vh;
    }
  }

  .end-modal-body {
    img {
      margin-bottom: 2vh;
      width: 100%;
    }

    .desktop-bg {
      @media screen and (max-width: 991px) {
        display: none;
      }
    }

    .mobile-bg {
      display: none;

      @media screen and (max-width: 991px) {
        display: block;
      }
    }

    div {
      color: #2f3a4c;
      font-size: 19.8px;
      text-align: center;
    }
  }
}
</style>